export const getActionOptions = (prefix: string) => ({ prefix, namespace: '/' });
